import { Modal } from "antd";
import { memo } from "react";
import { useSelector } from "react-redux";
import { formatDateToDDMMYYYY } from "utils/CommonFunctions";

const TesaPesaDischargeCardModal = ({ isOpen, onClose }) => {
  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="TESA/PESA Discharge Card Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => onClose()}
        width={860}
      >
        <div className="modal-details">
          <div className="modal-content-details">
            <div className="details">
              <div className="details-table">
                <div>Patient ID </div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                <div>Patient Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Partner Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Age</div>
                <div>{activePatientJourneyModuleDetails?.patient_dob}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Patient Details</div>
              <div className="details-table">
                <div>IVF ID</div>
                <div>{activePatientJourneyModuleDetails?.ivf_flow_id}</div>
                <div>M.S</div>
                <div>{activePatientJourneyModuleDetails?.married_since}</div>
                <div>DOA</div>
                <div>
                  {activePatientJourneyModuleDetails?.doa
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.doa
                      )
                    : ""}
                </div>
                <div>DOD</div>
                <div>
                  {activePatientJourneyModuleDetails?.dod
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.dod
                      )
                    : ""}
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Final Diagnosis Details</div>
              <div className="details-table">
                <div>Final Diagnosis</div>
                <div>{activePatientJourneyModuleDetails?.final_diagnosis}</div>
                <div>Chief Complaints</div>
                <div>{activePatientJourneyModuleDetails?.chief_complaints}</div>
                <div>Significant Findings Clinical Data</div>
                <div>{activePatientJourneyModuleDetails?.clinical_data}</div>
                <div>Relevant Investigations</div>
                <div>
                  {activePatientJourneyModuleDetails?.relevant_investigations}
                </div>
                <div>Notes</div>
                <div>{activePatientJourneyModuleDetails?.notes}</div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default memo(TesaPesaDischargeCardModal);
